import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate, Outlet } from "react-router-dom";
import { LayoutDashboard, Package, FolderTree, Settings, LogOut, BarChart3, ShoppingBag, FileText, Images } from "lucide-react";
import { useAuth } from "../../context/AuthContext";
import Logo from "../../components/Logo";

const NAV = [
    { to: "/admin", label: "Overview", icon: LayoutDashboard, end: true },
    { to: "/admin/products", label: "Products", icon: Package },
    { to: "/admin/media", label: "Media", icon: Images },
    { to: "/admin/categories", label: "Categories", icon: FolderTree },
    { to: "/admin/orders", label: "Orders", icon: ShoppingBag },
    { to: "/admin/analytics", label: "Analytics", icon: BarChart3 },
    { to: "/admin/policies", label: "Policies", icon: FileText },
    { to: "/admin/settings", label: "Settings", icon: Settings },
];

export default function AdminLayout() {
    const { user, logout } = useAuth();
    const loc = useLocation();
    const navigate = useNavigate();

    return (
        <div className="min-h-screen bg-ivory-200 flex" data-testid="admin-layout">
            <aside className="w-64 bg-white border-r border-sage-300/30 px-6 py-8 hidden md:flex flex-col">
                <Logo size="sm" />
                <p className="text-[10px] uppercase tracking-[0.3em] text-sage-600 mt-2">Admin Boutique</p>

                <nav className="mt-12 flex flex-col gap-1">
                    {NAV.map((n) => {
                        const active = n.end ? loc.pathname === n.to : loc.pathname.startsWith(n.to);
                        return (
                            <Link key={n.to} to={n.to} className={`flex items-center gap-3 rounded-xl px-4 py-2.5 text-sm transition-colors ${active ? "bg-sage-100 text-sage-700" : "text-ink-700 hover:bg-ivory-100"}`} data-testid={`admin-nav-${n.label.toLowerCase()}`}>
                                <n.icon size={16} strokeWidth={1.5} /> {n.label}
                            </Link>
                        );
                    })}
                </nav>

                <div className="mt-auto pt-8 border-t border-sage-300/30">
                    <p className="text-sm text-ink-900">{user?.name}</p>
                    <p className="text-xs text-ink-500">{user?.email}</p>
                    <button onClick={async () => { await logout(); navigate("/"); }} className="mt-3 inline-flex items-center gap-2 text-xs uppercase tracking-[0.2em] text-sage-700 hover:text-sage-600" data-testid="admin-logout-btn">
                        <LogOut size={14} /> Logout
                    </button>
                </div>
            </aside>
            <main className="flex-1 p-8 md:p-12 overflow-x-auto">
                <Outlet />
            </main>
        </div>
    );
}
